import React from 'react';
import type { ItemVerificationStatus } from '../types';
import { recordStatus, VERIFICATION_STATUS_LABEL } from '../utils/verification';

const STYLES: Record<ItemVerificationStatus, string> = {
  self_reported: 'bg-amber-50 text-amber-700 border-amber-200',
  evidence_supplied: 'bg-sky-50 text-sky-800 border-sky-200',
  manually_confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  verified: 'bg-indigo-50 text-indigo-800 border-indigo-200',
};

interface VerificationBadgeProps {
  status?: ItemVerificationStatus;
  className?: string;
  size?: 'sm' | 'md';
}

export const VerificationBadge: React.FC<VerificationBadgeProps> = ({
  status,
  className = '',
  size = 'md',
}) => {
  const resolved = recordStatus({ verification_status: status });
  const sizing = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold whitespace-nowrap ${STYLES[resolved]} ${sizing} ${className}`}
    >
      {resolved === 'verified' ? '✓ ' : ''}
      {VERIFICATION_STATUS_LABEL[resolved]}
    </span>
  );
};
